<div class="pagination flex gap-3" *ngIf="totalPage > 1">
  <button
    type="button"
    class="prev-btn cursor-pointer rounded-lg p-3 hover:bg-gray-100"
    (click)="onPrevPage()"
    [ngClass]="currentPage < 2 ? 'disabled' : ''">
    <fa-icon [icon]="faChevronLeft"></fa-icon>
  </button>
  <div class="page-number" *ngIf="currentPage > 5">
    <div
      class="page-box cursor-pointer rounded-lg border-b-2 border-transparent p-3 hover:bg-gray-100"
      (click)="changePage(1)">
      <div class="number">1</div>
    </div>
  </div>
  <div class="page-number" *ngIf="currentPage > 5">
    <div
      class="page-box dots cursor-pointer rounded-lg border-b-2 border-transparent p-3 hover:bg-gray-100">
      <div class="number">...</div>
    </div>
  </div>
  <div
    class="page-number"
    *ngFor="let page of showPageNumbers"
    [ngClass]="
      page == currentPage
        ? 'border-b-2 border-primary-md-dark'
        : 'border-b-2 border-transparent'
    ">
    <div
      class="page-box cursor-pointer rounded-lg p-3 hover:bg-gray-100"
      (click)="changePage(page)">
      <div class="number">{{ page }}</div>
    </div>
  </div>
  <div class="page-number" *ngIf="currentPage < totalPage - 5">
    <div
      class="page-box dots cursor-pointer rounded-lg border-b-2 border-transparent p-3 hover:bg-gray-100">
      <div class="number">...</div>
    </div>
  </div>
  <div class="page-number" *ngIf="currentPage < totalPage - 5">
    <div
      class="page-box cursor-pointer rounded-lg border-b-2 border-transparent p-3 hover:bg-gray-100"
      (click)="changePage(totalPage)">
      <div class="number">{{ totalPage }}</div>
    </div>
  </div>
  <button
    type="button"
    class="next-btn cursor-pointer rounded-lg p-3 hover:bg-gray-100"
    (click)="onNextPage()"
    [ngClass]="currentPage == totalPage ? 'disabled' : ''">
    <fa-icon [icon]="faChevronRight"></fa-icon>
  </button>
</div>
